import styled from 'styled-components';
import { RegularButton } from 'pg-ui-library';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ContainerItem = styled.div`
  display: flex;
`;

export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 20px;
  gap: 10px;
`;

export const TitleWrapperText = styled.span`
  display: flex;
  font-family: Biotif;
  font-weight: Regular;
  font-size: 18px;
  letter-spacing: 0px;
  align-items: center;
  color: #222247;
  ::after {
    content: '';
    flex: 1;
    margin-left: 1rem;
    height: 1px;
    background-color: #4948ac;
  }
`;

export const AccountDetailsContainer = styled.div`
  display: flex;
  column-gap: 20px;
  align-items: flex-end;
  @media only screen and (max-width: 1000px) {
    flex-direction: column;
  }
`;

export const AccountDetailsButtonContainer = styled.div`
  margin-top: 10px;
  button {
    margin: 0;
  }
`;

export const AccessAuthContainer = styled.div`
  display: flex;
  column-gap: 50px;

  @media only screen and (max-width: 1000px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const LastLoginText = styled.span`
  font-size: 16px;
  font-family: 'Segoe UI';
`;

export const MarginlessButton = styled(RegularButton)`
  margin: 0;
`;
